import { defHttp } from '/@/request';
import { ErrorMessageMode, Result } from '/#/axios';
import type { AxiosResponse } from 'axios';

import {
  LoginParamsModel,
  LoginResultModel,
  AuthResultModel,
  UpdatePasswordParamsModel,
  UpdateUserStateParamsModel,
  OnlineStatusResultModel,
  CheckBindParamsModel,
  CheckBindResultModel,
  AuthWhiteParamsModel,
  AuthWhiteResultModel,
  ChooseLoginParamsModel,
  CaptchaParamsModel,
  CaptchaResultModel,
  BindUserParamsModel,
} from './model/userModel';

enum Api {
  Login = 'tenant/auth/v1/password',
  Auth = 'tenant/auth/v1/auth',
  Logout = 'tenant/auth/v1/logOut',
  Password = 'tenant/user/v1/password',
  GetStatus = 'worksheet/rule/v1/work/state',
  ChangeStatus = 'worksheet/rule/v1/switch/work/state',
  CheckBind = 'tenant/auth/thirdapp/v1/check/bind', // 查看绑定关系
  ChooseLogin = 'tenant/auth/thirdapp/v1/choose/user/login', // 选择账号登录
  BindUser = 'tenant/auth/thirdapp/v1/bind/user', // 绑定账号
  AuthWhite = 'base/thirdapp/auth/v1/white', // 根据Oauth Code 获取openId
  Captcha = 'base/resource/captcha/v1/create', // 图形验证码
  ManualSummary = 'data/recognition/manual/v1/summary', // 首页列表
  SheetSummary = 'data/recognition/sheet/v1/summary', // 首页今日统计
  ManualExport = 'data/recognition/manual/v1/export', // 首页导出
  manualSheetList = 'data/recognition/manual/v1/sheet',
}

export function loginApi(data: LoginParamsModel, mode?: ErrorMessageMode) {
  console.log('reqData', data);
  return defHttp.post<Result<LoginResultModel>>(
    {
      url: Api.Login,
      data,
    },
    { errorMessageMode: mode || 'message' }
  );
}
export function authApi(data?: undefined, mode?: ErrorMessageMode) {
  return defHttp.post<Result<AuthResultModel>>(
    {
      url: Api.Auth,
    },
    { errorMessageMode: 'message' }
  );
}

export function getUserOnlineStatusApi(
  data?: undefined,
  mode?: ErrorMessageMode
) {
  return defHttp.post<Result<OnlineStatusResultModel>>(
    {
      url: Api.GetStatus,
    },
    { errorMessageMode: mode || 'message' }
  );
}
export function logOutApi(data?: undefined, mode?: ErrorMessageMode) {
  return defHttp.post<Result<null>>(
    {
      url: Api.Logout,
    },
    { errorMessageMode: mode || 'message' }
  );
}

export function passwordApi(
  data: UpdatePasswordParamsModel,
  mode?: ErrorMessageMode
) {
  return defHttp.post<Result<null>>(
    {
      url: Api.Password,
      data,
    },
    { errorMessageMode: mode || 'message' }
  );
}

export function changeUserStatusApi(
  data: UpdateUserStateParamsModel,
  mode?: ErrorMessageMode
) {
  return defHttp.post<Result<null>>(
    {
      url: Api.ChangeStatus,
      data,
    },
    { errorMessageMode: mode || 'message' }
  );
}

export function checkBindApi(data: CheckBindParamsModel) {
  return defHttp.post<Result<CheckBindResultModel>>({
    url: Api.CheckBind,
    data,
  });
}
export function authWhiteApi(data: AuthWhiteParamsModel) {
  return defHttp.post<Result<AuthWhiteResultModel>>({
    url: Api.AuthWhite,
    data,
  });
}
export function chooseLoginApi(data: ChooseLoginParamsModel) {
  return defHttp.post<Result<LoginResultModel>>({
    url: Api.ChooseLogin,
    data,
  });
}
export function bindUserApi(data: BindUserParamsModel) {
  return defHttp.post<Result<LoginResultModel>>({
    url: Api.BindUser,
    data,
  });
}
export function captchaApi(data: CaptchaParamsModel) {
  return defHttp.post<Result<CaptchaResultModel>>({
    url: Api.Captcha,
    data,
  });
}
export function recognitionSummaryApi(data: {
  startDate: string | undefined;
  endDate: string | undefined;
  page: number;
  pageSize: number;
}) {
  return defHttp.post<Result>({
    url: Api.ManualSummary,
    data,
  });
}
export function sheetSummaryApi() {
  return defHttp.post<Result>({
    url: Api.SheetSummary,
  });
}
// 导出

export function manualExportApi(
  data: { startDate: string; endDate: string },
  mode?: ErrorMessageMode
) {
  return defHttp.post<AxiosResponse<Blob>>(
    {
      url: Api.ManualExport,
      data,
      responseType: 'blob',
    },
    { errorMessageMode: mode || 'message', isReturnNativeResponse: true }
  );
}
export function manualSheetListApi(data: any) {
  return defHttp.post<Result<any>>({
    url: Api.manualSheetList,
    data,
  });
}
